import { createAction } from 'redux-act';

import * as impressionsReports from '../../core/impressionsReports';

export const fetchImpressionsCount = createAction(
  'get clicks leads count',
);
export const fetchImpressionsCountSuccess = createAction(
  'get clicks leads count success',
  (allApps) => allApps
);
export const fetchImpressionsCountFail = createAction(
  'get clicks leads count fail',
  (error) => error
);

export const fetchImpressionsAllCountries = createAction(
  'get clicks leads all countries',
);
export const fetchImpressionsAllCountriesSuccess = createAction(
  'get clicks leads all countries success',
  (allApps) => allApps
);
export const fetchImpressionsAllCountriesFail = createAction(
  'get clicks leads all countries fail',
  (error) => error
);

export const fetchImpressionsAllCampaigns = createAction(
  'get clicks leads all campaigns',
);
export const fetchImpressionsAllCampaignsSuccess = createAction(
  'get clicks leads all campaigns success',
  (allApps) => allApps
);
export const fetchImpressionsAllCampaignsFail = createAction(
  'get clicks leads all campaigns fail',
  (error) => error
);

export const fetchImpressionsStatistics = createAction(
  'get clicks statistics',
);
export const fetchImpressionsStatisticsSuccess = createAction(
  'get clicks statistics success',
  (allApps) => allApps
);
export const fetchImpressionsStatisticsFail = createAction(
  'get clicks statistics fail',
  (error) => error
);

export const fetchStoppedClicksGroups = createAction(
  'get clicks stopped clicks groups',
);
export const fetchStoppedClicksGroupsSuccess = createAction(
  'get clicks stopped clicks groups success',
  (allApps) => allApps
);
export const fetchStoppedClicksGroupsFail = createAction(
  'get clicks stopped clicks groups fail',
  (error) => error
);

export const reducer = {
  [fetchImpressionsCount]: (state, payload) =>
    impressionsReports.fetchImpressionsCount(state, payload),
  [fetchImpressionsCountSuccess]: (state, payload) =>
    impressionsReports.fetchImpressionsCountSuccess(state, payload),
  [fetchImpressionsCountFail]: (state, payload) =>
    impressionsReports.fetchImpressionsCountFail(state, payload),

  [fetchImpressionsAllCountries]: (state, payload) =>
    impressionsReports.fetchImpressionsAllCountries(state, payload),
  [fetchImpressionsAllCountriesSuccess]: (state, payload) =>
    impressionsReports.fetchImpressionsAllCountriesSuccess(state, payload),
  [fetchImpressionsAllCountriesFail]: (state, payload) =>
    impressionsReports.fetchImpressionsAllCountriesFail(state, payload),

  [fetchImpressionsAllCampaigns]: (state, payload) =>
    impressionsReports.fetchImpressionsAllCampaigns(state, payload),
  [fetchImpressionsAllCampaignsSuccess]: (state, payload) =>
    impressionsReports.fetchImpressionsAllCampaignsSuccess(state, payload),
  [fetchImpressionsAllCampaignsFail]: (state, payload) =>
    impressionsReports.fetchImpressionsAllCampaignsFail(state, payload),

  [fetchImpressionsStatistics]: (state, payload) =>
    impressionsReports.fetchImpressionsStatistics(state, payload),
  [fetchImpressionsStatisticsSuccess]: (state, payload) =>
    impressionsReports.fetchImpressionsStatisticsSuccess(state, payload),
  [fetchImpressionsStatisticsFail]: (state, payload) =>
    impressionsReports.fetchImpressionsStatisticsFail(state, payload),

  [fetchStoppedClicksGroups]: (state, payload) =>
    impressionsReports.fetchStoppedClicksGroups(state, payload),
  [fetchStoppedClicksGroupsSuccess]: (state, payload) =>
    impressionsReports.fetchStoppedClicksGroupsSuccess(state, payload),
  [fetchStoppedClicksGroupsFail]: (state, payload) =>
    impressionsReports.fetchStoppedClicksGroupsFail(state, payload),
};



/** WEBPACK FOOTER **
 ** ./js/redux/modules/impressionsReports.module.js
 **/